import { crmRequest, isEmpty } from '@meta-vue/util'
import store from '~/store'
import { CALLOUT_MESSAGE_TYPE } from '@/assets/constant/call'

import { USER_CONFIG_TYPE } from '@/util/const'

const CONFIG_CHANGE_STORE_KEY = '__CALL_USER_CONFIG_CHANGE__'

/**
 * 该方法使用场景如下：
 * 目前有两个项目(crm-sales-workbench/h5newcallcenter)都可配置，故在一个项目中配置了需要同步更新拎一个项目的配置
 * 此处使用监听localStorage change的方式来更新
 * 为什么不在每次使用的时候调用接口？
 * 该配置每个配置都用在不同的地方，且用法各不相同，且每个配置生效的都不同，例如话后处理时长，实在每次外呼前生效。
 * 故通过每次都调用接口的方式是实现成本较高啊，切会增加外呼链路的复杂度和等待时间。
 * @param {*} e
 */
function watchLocalStorageChange(e) {
  const { key } = e
  if (key === CONFIG_CHANGE_STORE_KEY) {
    store.dispatch('callUserConfig/getCallUserConfig')
  }
}

function setUserConfig(data, silent = false) {
  return crmRequest('/callcenter-app/userCfg/save', {
    method: 'post',
    data: { cfg: data, cfgType: USER_CONFIG_TYPE.codes.CALL_CONFIG },
    silent
  }).catch(e => (silent ? Promise.resolve() : Promise.reject(e)))
}

export default {
  state: {
    showRingingTime: false, // 是否实时展示振铃时长
    autoCallPostCallTime: 30, // 自动外呼话后处理时长
    aiCallPostCallTime: 10, // AI外呼转人工话后处理时长
    predictiveCallPostCallTime: 3 // 预测外呼话后处理时长
  },
  actions: {
    initCallUserConfig({ dispatch }) {
      window.addEventListener('storage', watchLocalStorageChange)
      dispatch('getCallUserConfig')
    },
    destroy() {
      window.removeEventListener('storage', watchLocalStorageChange)
    },
    async getCallUserConfig({ dispatch, rootState }) {
      // try {
      //   const userConfig = (
      //     await crmRequest('/callcenter-app/userCfg/query', {
      //       method: 'post',
      //       data: {
      //         cfgType: USER_CONFIG_TYPE.codes.CALL_CONFIG
      //       },
      //       silent: true
      //     }).catch(e => {
      //       return {}
      //     })
      //   )?.cfg
      //   let { showRingingTime = false, autoCallPostCallTime, aiCallPostCallTime, predictiveCallPostCallTime } =
      //     JSON.parse(userConfig) || {}
      //   const userId = rootState?.Authentication?.user?.id
      //   // 针对接口获取的数据无知的情况，兼容老逻辑获取默认值，并重新调用接口存储到后端
      //   let needUpdate = false
      //   // 以下代码兼容老逻辑，若接口未返回值，则取缓存中的值
      //   if (autoCallPostCallTime == null) {
      //     needUpdate = true
      //     autoCallPostCallTime = localStorage?.getItem?.(`${userId}_after_call_duration`) || 30 // 最小值1，故不会出现0的情况
      //   }
      //   if (aiCallPostCallTime == null) {
      //     needUpdate = true
      //     aiCallPostCallTime = localStorage?.getItem?.(`__AI_POST_TALKING_TIME_${userId}__`)
      //     if (isEmpty(aiCallPostCallTime)) aiCallPostCallTime = 10
      //   }
      //   if (predictiveCallPostCallTime == null) {
      //     needUpdate = true
      //     predictiveCallPostCallTime = localStorage?.getItem?.(`__$$PREDICTIVE_CALL_POST_TALKING_TIME_${userId}__`)
      //     if (isEmpty(predictiveCallPostCallTime)) predictiveCallPostCallTime = 3
      //   }
      //   const dispatchFunc = needUpdate ? 'autoSaveCallUserConfig' : 'setCallUserConfigLocal'
      //   dispatch(dispatchFunc, {
      //     showRingingTime,
      //     autoCallPostCallTime,
      //     aiCallPostCallTime,
      //     predictiveCallPostCallTime
      //   })
      //   // 获取数据后重新设置话后处理时长
      // } catch (e) {
      //   console.log(e)
      // }
    },
    // 通知弹屏配置更新
    postMessage({ state }) {
      const message = {
        origin: 'main',
        type: CALLOUT_MESSAGE_TYPE.USER_CONFIG_CHANGE
      }
      document.getElementById('calloutIframe')?.contentWindow?.postMessage &&
        document.getElementById('calloutIframe').contentWindow.postMessage(message)
    },
    async autoSaveCallUserConfig({ commit, dispatch, state }, userConfig) {
      await setUserConfig(JSON.stringify(userConfig), true)

      commit('SET_USER_CONFIG', userConfig)

      localStorage.setItem(CONFIG_CHANGE_STORE_KEY, JSON.stringify(userConfig))
      dispatch('postMessage')
    },
    async setCallUserConfig({ commit, dispatch, state }, userConfig) {
      await setUserConfig(JSON.stringify(userConfig))

      commit('SET_USER_CONFIG', userConfig)

      localStorage.setItem(CONFIG_CHANGE_STORE_KEY, JSON.stringify(userConfig))
      dispatch('postMessage')
    },
    async setCallUserConfigLocal({ commit, dispatch, state, rootState }, userConfig) {
      console.log('setCallUserConfigLocal', userConfig)
      commit('SET_USER_CONFIG', userConfig)
    }
  },
  mutations: {
    SET_USER_CONFIG(state, { showRingingTime, autoCallPostCallTime, aiCallPostCallTime, predictiveCallPostCallTime }) {
      state.showRingingTime = showRingingTime
      state.autoCallPostCallTime = +autoCallPostCallTime
      state.aiCallPostCallTime = +aiCallPostCallTime
      state.predictiveCallPostCallTime = +predictiveCallPostCallTime
    },
    SET_USER_CONFIG_BY_KEY(state, { key, value }) {
      state[key] = value
    }
  }
}
